import type { IPersona, IPersonaFilters } from '@rpgc-ai/shared-interfaces/interfaces/persona.interface';

export interface PersonaState {
  personas: IPersona[];
  selectedPersona: IPersona | null;
  defaultUserPersona: IPersona | null;
  total: number;
  isLoading: boolean;
  error: string | null;
  filters: IPersonaFilters;
  navigateOnSuccess: boolean;
  selectedPersonaId: string | null;
}

export const initialPersonaState: PersonaState = {
  personas: [],
  selectedPersona: null,
  defaultUserPersona: null,
  total: 0,
  filters: {
    sortOrder: 'desc',
    limit: 20,
    page: 1,
  },
  isLoading: false,
  error: null,
  navigateOnSuccess: false,
  selectedPersonaId: null,
};
